const tokens = {
  backgroundColor: "#1d1d1d",
  bodyTextColor: "#F1DADE",
  secondaryTextColor: "#ffffff",
  highlightTextColor: "#f091a1",
};

export default tokens;
